//
//
//
//
//
//
//

export default {
name: "FddIcon"
}
